var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBook28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.1965 3.10265C2.32035 3.00806 2.48121 2.97662 2.63156 3.01762L13.5 5.98174L24.3684 3.01762C24.5188 2.97662 24.6797 3.00806 24.8035 3.10265C24.9273 3.19724 25 3.34417 25 3.5V18.5C25 18.7255 24.8491 18.9231 24.6316 18.9824L13.6426 21.9794C13.6063 21.9901 13.5683 21.9969 13.5291 21.9992C13.5194 21.9997 13.5097 22 13.5 22C13.4917 22 13.4834 21.9998 13.4751 21.9994C13.4344 21.9974 13.395 21.9905 13.3574 21.9794L2.36844 18.9824C2.15091 18.9231 2 18.7255 2 18.5V3.5C2 3.34417 2.07266 3.19724 2.1965 3.10265ZM24 18.1181L14 20.8454V6.8819L24 4.15463V18.1181ZM3 4.15463L13 6.8819V20.8454L3 18.1181V4.15463ZM3 22.5C3 22.2239 2.77614 22 2.5 22C2.22386 22 2 22.2239 2 22.5V24.5C2 24.7761 2.22386 25 2.5 25H24.5C24.7761 25 25 24.7761 25 24.5V22.5C25 22.2239 24.7761 22 24.5 22C24.2239 22 24 22.2239 24 22.5V24H3V22.5Z",
  fill: "currentColor"
})));
export default SvgBook28;